module.exports = __webpack_public_path__ + "img/linea1-3.21d5b525.png";